import { jsxs as u, jsx as i } from "react/jsx-runtime";
import { QUERIES as J } from "@fcamna/shared-component-foundations";
import { fordProIcons as ke } from "@fcamna/shared-icons";
import { useState as d, useRef as C, useEffect as Se } from "react";
import m, { useTheme as xe } from "styled-components";
import { u as Ae } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as h } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "react-dom";
import "./_commonjsHelpers-92157f1b.mjs";
const { ClosedCaptions: Ee, Expand: Ie, Mute: ze, Pause: De, PlayFilled: Ue, ShareAndroid: Re, Volume: We } = ke, Me = m.div`
  --thumbSize: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer["--thumbSize"]};
  --volumeBarWidth: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer["--volumeBarWidth"]};

  display: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.display};
  position: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.position};
  max-width: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.maxWidth};
  max-height: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.maxHeight};

  // hide default full screen controls
  video::-webkit-media-controls {
    display: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.video.webkitMediaControls.display} !important;
  }

  &:hover {
    div {
      opacity: ${(e) => e.theme.components.videoPlayer.VideoPlayerContainer.hover.div.opacity};
    }
  }
`, je = m.video`
  max-width: ${(e) => e.theme.components.videoPlayer.VideoPlayerElement.maxWidth};
  max-height: ${(e) => e.theme.components.videoPlayer.VideoPlayerElement.maxHeight};
`, Fe = m.div`
  opacity: ${(e) => e.theme.components.videoPlayer.VideoControls.opacity};
  overflow: ${(e) => e.theme.components.videoPlayer.VideoControls.overflow};
  transition: ${(e) => e.theme.components.videoPlayer.VideoControls.transition};
  position: ${(e) => e.theme.components.videoPlayer.VideoControls.position};
  bottom: ${(e) => e.theme.components.videoPlayer.VideoControls.bottom};
  left: ${(e) => e.theme.components.videoPlayer.VideoControls.left};
  right: ${(e) => e.theme.components.videoPlayer.VideoControls.right};
  background-color: ${(e) => e.theme.components.videoPlayer.VideoControls.backgroundColor};
  color: ${(e) => e.theme.components.videoPlayer.VideoControls.color};
  display: ${(e) => e.theme.components.videoPlayer.VideoControls.display};
  justify-content: ${(e) => e.theme.components.videoPlayer.VideoControls.justifyContent};
  align-items: ${(e) => e.theme.components.videoPlayer.VideoControls.alignItems};
  padding: ${(e) => e.theme.components.videoPlayer.VideoControls.padding};
  flex-direction: ${(e) => e.theme.components.videoPlayer.VideoControls.flexDirection};

  &:focus-within {
    opacity: ${(e) => e.theme.components.videoPlayer.VideoControls.focusWithin.opacity};
  }
`, v = m.button`
  background-color: ${(e) => e.theme.components.videoPlayer.ButtonElement.backgroundColor};
  border: ${(e) => e.theme.components.videoPlayer.ButtonElement.border};
  color: ${(e) => e.theme.components.videoPlayer.ButtonElement.color};
  margin-right: ${(e) => e.theme.components.videoPlayer.ButtonElement.marginRight};
  padding: ${(e) => e.theme.components.videoPlayer.ButtonElement.padding};
  display: ${(e) => e.theme.components.videoPlayer.ButtonElement.display};
  align-items: ${(e) => e.theme.components.videoPlayer.ButtonElement.alignItems};
  justify-content: ${(e) => e.theme.components.videoPlayer.ButtonElement.justifyContent};

  &:not(:disabled) {
    cursor: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.cursor};

    &:hover {
      background-color: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.hover.backgroundColor};
      border-radius: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.hover.borderRadius};
    }

    &:focus-visible {
      outline: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.outline};
      box-shadow: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.boxShadow};
      border-radius: ${(e) => e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.borderRadius};
    }
  }

  & > svg {
    width: ${(e) => e.theme.components.videoPlayer.ButtonElement.svg.width};
    height: ${(e) => e.theme.components.videoPlayer.ButtonElement.svg.height};
  }

  &:disabled {
    color: ${(e) => e.theme.components.videoPlayer.ButtonElement.disabled.color};
  }
`, He = m(v)`
  border-bottom: ${(e) => e.theme.components.videoPlayer.SubtitlesButton.borderBottom};
  padding: ${(e) => e.theme.components.videoPlayer.SubtitlesButton.padding};

  &:not(:disabled) {
    ${(e) => e.showSubtitles ? `
        border-bottom: ${e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottom};
        border-bottom-left-radius: ${e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottomLeftRadius} !important;
        border-bottom-right-radius: ${e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottomRightRadius} !important;
      ` : ""}
  }
`, Ke = m.div`
  position: ${(e) => e.theme.components.videoPlayer.ProgressBar.position};
  width: ${(e) => e.theme.components.videoPlayer.ProgressBar.width};
  height: ${(e) => e.theme.components.videoPlayer.ProgressBar.height};
  overflow: ${(e) => e.theme.components.videoPlayer.ProgressBar.overflow};
  margin-bottom: ${(e) => e.theme.components.videoPlayer.ProgressBar.marginBottom};
  background: ${(e) => e.theme.components.videoPlayer.ProgressBar.background};
  border-radius: ${(e) => e.theme.components.videoPlayer.ProgressBar.borderRadius};
  cursor: ${(e) => e.theme.components.videoPlayer.ProgressBar.cursor};

  &:focus-visible {
    outline: ${(e) => e.theme.components.videoPlayer.ProgressBar.focusVisible.outline};
    outline-offset: ${(e) => e.theme.components.videoPlayer.ProgressBar.focusVisible.outlineOffset};
  }

  & > div {
    position: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.position};
    top: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.top};
    left: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.left};
    height: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.height};
    border-radius: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.borderRadius};
    width: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.width};
    transition: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.transition};

    &:nth-of-type(1) {
      background: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.nthOfType1.background};
      z-index: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.nthOfType1.zIndex};
    }

    &:nth-of-type(2) {
      background: ${(e) => e.theme.components.videoPlayer.ProgressBar.div.nthOfType2.background};
    }
  }
`, Le = m.div`
  display: ${(e) => e.theme.components.videoPlayer.VideoButtonsContainer.display};
  flex-direction: ${(e) => e.theme.components.videoPlayer.VideoButtonsContainer.flexDirection};
  width: ${(e) => e.theme.components.videoPlayer.VideoButtonsContainer.width};
  justify-content: ${(e) => e.theme.components.videoPlayer.VideoButtonsContainer.justifyContent};
`, G = m.div`
  display: ${(e) => e.theme.components.videoPlayer.VideoButtonsSection.display};
  flex-direction: ${(e) => e.theme.components.videoPlayer.VideoButtonsSection.flexDirection};
  align-items: ${(e) => e.theme.components.videoPlayer.VideoButtonsSection.alignItems};
`, qe = m.div`
  display: ${(e) => e.theme.components.videoPlayer.TimeContainer.display};
  align-items: ${(e) => e.theme.components.videoPlayer.TimeContainer.alignItems};
  font-family: ${(e) => e.theme.components.videoPlayer.TimeContainer.fontFamily};
  font-style: ${(e) => e.theme.components.videoPlayer.TimeContainer.fontStyle};
  font-weight: ${(e) => e.theme.components.videoPlayer.TimeContainer.fontWeight};
  font-size: ${(e) => e.theme.components.videoPlayer.TimeContainer.fontSize};
  line-height: ${(e) => e.theme.components.videoPlayer.TimeContainer.lineHeight};
  color: ${(e) => e.theme.components.videoPlayer.TimeContainer.color};
`, Qe = m.input`
  -webkit-appearance: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitAppearance};
  max-width: ${(e) => e.theme.components.videoPlayer.VolumeBar.maxWidth};
  width: ${(e) => e.theme.components.videoPlayer.VolumeBar.width};
  height: ${(e) => e.theme.components.videoPlayer.VolumeBar.height};
  transition: ${(e) => e.theme.components.videoPlayer.VolumeBar.transition};
  background: ${(e) => e.theme.components.videoPlayer.VolumeBar.background};
  cursor: ${(e) => e.theme.components.videoPlayer.VolumeBar.cursor};
  margin-right: ${(e) => e.theme.components.videoPlayer.VolumeBar.marginRight};

  &::-webkit-slider-thumb {
    -webkit-appearance: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.WebkitAppearance};
    border-radius: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.borderRadius};
    cursor: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.cursor};
    width: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.width};
    height: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.height};
    transition: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.transition};
    background: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.background};
    border: ${(e) => e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.border};
  }

  &::-moz-range-thumb {
    -webkit-appearance: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.webkitAppearance};
    border-radius: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.borderRadius};
    cursor: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.cursor};
    width: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.width};
    height: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.height};
    transition: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.transition};
    background: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.background};
    border: ${(e) => e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.border};
  }

  &:focus {
    outline: ${(e) => e.theme.components.videoPlayer.VolumeBar.focus.outline};
  }

  @media ${J.tabletAndUp} and (hover: hover) {
    &:focus-visible {
      outline: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.outline};
      outline-offset: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.outlineOffset};
      width: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.width};
      max-width: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.maxWidth};
      margin-right: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.marginRight};
      border-radius: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.borderRadius};

      &::-webkit-slider-thumb {
        width: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.webkitSliderThumb.width};

        height: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.webkitSliderThumb.height};
      }

      &::-moz-range-thumb {
        width: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.mozRangeThumb.width};

        height: ${(e) => e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.mozRangeThumb.height};
      }
    }
  }
`, Xe = m.div`
  display: ${(e) => e.theme.components.videoPlayer.VolumeContainer.display};
  align-items: ${(e) => e.theme.components.videoPlayer.VolumeContainer.alignItems};

  @media ${J.tabletAndUp} and (hover: hover) {
    &:hover {
      input[type='range'] {
        width: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.width};
        max-width: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.maxWidth};
        margin-right: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.marginRight};

        &::-webkit-slider-thumb {
          width: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.webkitSliderThumb.width};
          height: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.webkitSliderThumb.height};
        }

        &::-moz-range-thumb {
          width: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.mozRangeThumb.width};
          height: ${(e) => e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.mozRangeThumb.height};
        }
      }
    }
  }
`;
function mo({
  src: e,
  isMuted: N = !1,
  shouldAutoPlay: Y = !1,
  shouldLoop: Z = !1,
  subtitlesOnByDefault: _ = !1,
  children: O,
  onTimeUpdate: T,
  onEnded: k,
  onPlay: S,
  onPause: x,
  onLoadedMetadata: A,
  onProgress: E,
  accessibilityOptions: r,
  ...ee
}) {
  var L, q, Q, X;
  const oe = Ae({ label: "Video Player" }), [I, z] = d(!1), [y, te] = d(_), [U, ne] = d(!1), [re, R] = d(0), [P, g] = d(0), [b, W] = d(N ? 0 : 1), [M, ie] = d(1), [$, B] = d(-1), [le, ae] = d("0:00"), t = C(null), f = C(null), V = C(null), w = C(null), c = xe();
  function D() {
    const o = t == null ? void 0 : t.current;
    I ? o.pause() : o.play();
  }
  function me() {
    z(!1), clearInterval($), B(-1), k == null || k();
  }
  function de() {
    const o = t == null ? void 0 : t.current;
    if (ae(Pe()), o.textTracks.length) {
      if (!y)
        for (let n = 0; n < o.textTracks.length; n++)
          o.textTracks[n].mode = "hidden";
      ne(!0);
    }
    A == null || A();
  }
  function se() {
    j(), E == null || E();
  }
  function j() {
    const o = t == null ? void 0 : t.current, n = o == null ? void 0 : o.buffered, a = o.duration, l = o.currentTime;
    let s = 0, p = 0;
    try {
      for (; !(n.start(s) <= l && l <= n.end(s)); )
        s += 1;
      p = n.end(s);
    } catch {
      return R(0);
    }
    R(Math.ceil(p / a * 100));
  }
  function ue() {
    j(), T == null || T();
  }
  function F(o) {
    const n = parseFloat(o.target.value), a = t == null ? void 0 : t.current;
    a.muted = !1, W(n), a.volume = n, H(n, o.target);
  }
  function H(o, n) {
    const a = o * 100, l = "#fff", s = "rgba(255, 255, 255, 0.3)";
    n.style.background = `linear-gradient(to right, ${l} 0%,
      ${l} ${a}%, ${s} ${a}%, ${s} 100%)`;
  }
  function he() {
    ie(b);
    const o = t == null ? void 0 : t.current;
    o.muted = !o.muted, W(o.muted ? 0 : M), H(o.muted ? 0 : M, w == null ? void 0 : w.current);
  }
  function ce() {
    const o = f == null ? void 0 : f.current;
    document.fullscreenElement ? document.exitFullscreen() : o.requestFullscreen();
  }
  function pe() {
    z(!0);
    const o = t == null ? void 0 : t.current, n = setInterval(function() {
      g(o.currentTime);
    }, 30);
    B(n), S == null || S();
  }
  function ve() {
    z(!1), clearInterval($), B(-1), x == null || x();
  }
  function ye() {
    const o = Math.floor(P / 60);
    let n = Math.floor(P % 60).toString();
    return parseInt(n) < 10 && (n = `0${n}`), `${o}:${n}`;
  }
  function Pe() {
    const o = t == null ? void 0 : t.current, n = (o == null ? void 0 : o.duration) ?? 0, a = Math.floor(n / 60);
    let l = Math.floor(n % 60).toString();
    return parseInt(l) < 10 && (l = `0${l}`), `${a}:${l}`;
  }
  function ge(o) {
    const n = t == null ? void 0 : t.current, a = V == null ? void 0 : V.current, l = a.offsetWidth, p = (o.clientX - a.getBoundingClientRect().left) / l * n.duration;
    n.currentTime = p, g(p);
  }
  function be(o) {
    const n = t == null ? void 0 : t.current, a = 1;
    if (o.key === "ArrowRight") {
      const l = Math.min(n.currentTime + a, n.duration);
      n.currentTime = l, g(l);
    } else if (o.key === "ArrowLeft") {
      const l = Math.max(n.currentTime - a, 0);
      n.currentTime = l, g(l);
    } else
      (o.key === " " || o.key === "Enter") && D();
  }
  function $e(o) {
    if (U) {
      const n = t == null ? void 0 : t.current;
      y ? n.textTracks[0].mode = "hidden" : n.textTracks[0].mode = "showing", te(!y);
    }
  }
  Se(() => () => {
    $ >= 0 && (clearInterval($), B(-1));
  }, []);
  const Be = h("progressbar", {
    ariaValuMax: (L = t == null ? void 0 : t.current) == null ? void 0 : L.duration,
    ariaValuenow: P,
    ...r == null ? void 0 : r.videoProgressBar
  }), fe = h("slider", {
    ariaValuMax: 1,
    ariaValuenow: b,
    ...r == null ? void 0 : r.volumeSlider
  }), Ve = h("button", {
    ...r == null ? void 0 : r.volumeButton
  }), we = h("button", {
    ...r == null ? void 0 : r.shareButton
  }), Ce = h("button", {
    ...r == null ? void 0 : r.subTitleButton
  }), Te = h("button", {
    ...r == null ? void 0 : r.fullScreenButton
  }), K = {
    playButton: h("button", {
      ...(q = r == null ? void 0 : r.videoPlayButton) == null ? void 0 : q.playButton
    }),
    pauseButton: h("button", {
      ...(Q = r == null ? void 0 : r.videoPlayButton) == null ? void 0 : Q.pauseButton
    })
  };
  return /* @__PURE__ */ u(
    Me,
    {
      ref: f,
      ...ee,
      ...oe,
      children: [
        /* @__PURE__ */ i(
          je,
          {
            src: e || void 0,
            ref: t,
            onTimeUpdate: ue,
            onEnded: me,
            onPlay: pe,
            onClick: D,
            onPause: ve,
            onLoadedMetadata: de,
            onProgress: se,
            controls: !1,
            loop: Z,
            autoPlay: Y,
            children: O
          }
        ),
        /* @__PURE__ */ u(Fe, { children: [
          /* @__PURE__ */ u(
            Ke,
            {
              onClick: ge,
              onKeyDown: be,
              ref: V,
              tabIndex: 0,
              ...Be,
              children: [
                /* @__PURE__ */ i(
                  "div",
                  {
                    style: {
                      width: `${P / ((X = t == null ? void 0 : t.current) == null ? void 0 : X.duration) * 100}%`
                    }
                  }
                ),
                /* @__PURE__ */ i(
                  "div",
                  {
                    style: {
                      width: `${re}%`
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ u(Le, { children: [
            /* @__PURE__ */ u(G, { children: [
              /* @__PURE__ */ i(
                v,
                {
                  onClick: D,
                  ...I ? K.pauseButton : K.playButton,
                  children: I ? /* @__PURE__ */ i(De, {}) : /* @__PURE__ */ i(Ue, {})
                }
              ),
              /* @__PURE__ */ u(Xe, { children: [
                /* @__PURE__ */ i(
                  v,
                  {
                    onClick: he,
                    style: {
                      marginRight: c.components.videoPlayer.InlineStyles.VolumeContainerButtonElement.marginRight
                    },
                    ...Ve,
                    children: b === 0 ? /* @__PURE__ */ i(ze, {}) : /* @__PURE__ */ i(We, {})
                  }
                ),
                /* @__PURE__ */ i(
                  Qe,
                  {
                    type: "range",
                    min: "0",
                    max: "1",
                    step: "0.01",
                    value: b,
                    onChange: F,
                    ref: w,
                    onKeyDown: F,
                    ...fe
                  }
                )
              ] }),
              /* @__PURE__ */ u(qe, { children: [
                /* @__PURE__ */ i(
                  "div",
                  {
                    style: {
                      minWidth: c.components.videoPlayer.InlineStyles.TimeContainer.minWidth
                    },
                    children: ye()
                  }
                ),
                /* @__PURE__ */ i(
                  "div",
                  {
                    style: {
                      marginRight: c.components.videoPlayer.InlineStyles.TimeContainer.marginRight
                    },
                    children: "/"
                  }
                ),
                /* @__PURE__ */ i(
                  "div",
                  {
                    style: {
                      minWidth: c.components.videoPlayer.InlineStyles.TimeContainer.minWidth
                    },
                    children: le
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u(G, { children: [
              /* @__PURE__ */ i(
                He,
                {
                  disabled: !U,
                  onClick: $e,
                  showSubtitles: y,
                  ...Ce,
                  children: /* @__PURE__ */ i(
                    Ee,
                    {
                      style: {
                        width: c.components.videoPlayer.InlineStyles.SubtitlesButton.width,
                        height: c.components.videoPlayer.InlineStyles.SubtitlesButton.height
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ i(
                v,
                {
                  disabled: !0,
                  ...we,
                  children: /* @__PURE__ */ i(Re, {})
                }
              ),
              /* @__PURE__ */ i(
                v,
                {
                  onClick: ce,
                  style: {
                    marginRight: c.components.videoPlayer.InlineStyles.FullScreenButtonElement.marginRight
                  },
                  ...Te,
                  children: /* @__PURE__ */ i(Ie, {})
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
}
export {
  mo as VideoPlayer
};
